import { render, staticRenderFns } from "./NewsTable.vue?vue&type=template&id=db05abee&scoped=true"
import script from "./NewsTable.vue?vue&type=script&lang=js"
export * from "./NewsTable.vue?vue&type=script&lang=js"
import style0 from "./NewsTable.vue?vue&type=style&index=0&id=db05abee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db05abee",
  null
  
)

export default component.exports